import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "column" }
const _hoisted_2 = { class: "column" }
const _hoisted_3 = { class: "column" }
const _hoisted_4 = { class: "column" }

import {
  PieChart01,
  TypeSquare,
  Phone,
  Microphone01,
  Image03,
  PieChart02,
  Trash01,
  Edit02,
  Clock,
  PhoneHangUp,
} from "utruckin-icons";

import CustomPanel from "@/components/custom/CustomPanel.vue";
import {useStatsStore} from "@/features/stats/stats.store";
import {ICountFilter, IFilter} from "@/types/main";
import {computed, ref, watch} from "vue";
import {useAppStore} from "@/store/app.store";
import {useRoute} from "vue-router";

interface IProps {
  type: 'messages' | 'chats' | 'groups';
  position: "horizontal" | "vertical";
  filter: IFilter;
  store: any;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'WidgetPanels',
  props: {
    type: {},
    position: { default: "horizontal" },
    filter: {},
    store: {}
  },
  setup(__props: any) {

const store = useStatsStore();
const appStore = useAppStore();
const route = useRoute();

const loading = ref<boolean>(false);
const data = ref()


const props = __props;

const countFilter = computed(() => {
  if (props.filter) {
    return {
      account_id: props.filter.account,
      time_from: props.filter.time_from,
      time_to: props.filter.time_to,
      date_from: props.filter.date_from,
      date_to: props.filter.date_to,
      shift_id: props.filter.shift,
    }
  }
})

const getInfo = async () => {
  data.value = await store.getStats(countFilter.value as ICountFilter, loading);
}

const info = computed(() => {
  const isMessages = props.type === 'messages';
  const isChatsUser = props.type === 'chats';

  const source = isMessages
      ? data.value
      : isChatsUser
          ? data.value?.chats?.user
          : data.value?.chats?.group;

  return {
    messages: {
      total: source?.messages?.total ?? 0,
      text: source?.messages?.text ?? 0,
      calls: source?.messages?.calls ?? 0,
      voice:
          (source?.messages?.voice ?? 0) +
          (source?.messages?.document ?? 0) +
          (source?.messages?.audio ?? 0),
      photo_video:
          (source?.messages?.photo ?? 0) +
          (source?.messages?.video ?? 0) +
          (source?.messages?.round ?? 0),
    },
    errors: {
      total: source?.errors?.total ?? 0,
      reply_time: source?.errors?.reply_time_exceed ?? 0,
      deleted: source?.errors?.deleted ?? 0,
      edited: source?.errors?.edited ?? 0,
      unanswered:
          (source?.errors?.declined_calls ?? 0) +
          (source?.errors?.missed_calls ?? 0),
    }
  };
});

const filterPanels = () => {
  if (store.panels.allMessages) {
    for (let panelsKey in props.store.additionalFilter) {
      props.store.additionalFilter[panelsKey] = null;
    }

    return
  } else {
    if (store.panels.allErrors) {
      props.store.additionalFilter.is_deleted = true
      props.store.additionalFilter.is_edited = true
      props.store.additionalFilter.missed_call = true
      props.store.additionalFilter.declined_call = true
      props.store.additionalFilter.reply_time_exceed = true

      props.store.additionalFilter.messages_text = false
      props.store.additionalFilter.messages_photo = false
      props.store.additionalFilter.messages_video = false
      props.store.additionalFilter.messages_voice = false
      props.store.additionalFilter.messages_round = false
      props.store.additionalFilter.messages_audio = false
      props.store.additionalFilter.messages_document = false

      return
    } else {

      for (let panelsKey in props.store.additionalFilter) {
        props.store.additionalFilter[panelsKey] = false;
      }

      if (store.panels.text) {
        props.store.additionalFilter.messages_text = true
      }

      if (store.panels.call) {
        props.store.additionalFilter.calls = true
      }

      if (store.panels.voice) {
        props.store.additionalFilter.messages_voice = true
        props.store.additionalFilter.messages_document = true
        props.store.additionalFilter.messages_audio = true
      }

      if (store.panels.photo) {
        props.store.additionalFilter.messages_photo = true
        props.store.additionalFilter.messages_video = true
        props.store.additionalFilter.messages_round = true
      }

      if (store.panels.replyTime) {
        props.store.additionalFilter.reply_time_exceed = true
      }

      if (store.panels.unanswered) {
        props.store.additionalFilter.missed_call = true
        props.store.additionalFilter.declined_call = true
      }

      if (store.panels.deleted) {
        props.store.additionalFilter.is_deleted = true
      }

      if (store.panels.edited) {
        props.store.additionalFilter.is_edited = true
      }
    }
  }
}

watch(
    [
      () => appStore.refreshKey,
      () => JSON.stringify(countFilter.value),
    ],
    () => {
      getInfo()
    },
    {immediate: true}
)

watch(
    () => JSON.stringify(store.panels),
    () => {
      if (props.type == 'messages') {
        filterPanels()
      }
    }
)

watch(
    () => route.path,
    () => {
      store.setDefaultPanels()
    },
    {immediate: true}
)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["c-w-panels", __props.position])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(CustomPanel, {
        icon: _unref(PieChart01),
        number: info.value.messages.total,
        size: "large",
        label: "All Message",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(store).selectPanel('allMessages'))),
        "is-active": _unref(store).panels.allMessages
      }, null, 8, ["icon", "number", "is-active"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(CustomPanel, {
        number: info.value.messages.text,
        label: "Text",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(store).selectPanel('text'))),
        "is-active": _unref(store).panels.text
      }, null, 8, ["number", "is-active"]),
      _createVNode(CustomPanel, {
        number: info.value.messages.calls,
        label: "Call",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(store).selectPanel('call'))),
        "is-active": _unref(store).panels.call
      }, null, 8, ["number", "is-active"]),
      _createVNode(CustomPanel, {
        number: info.value.messages.voice,
        label: "Voice & Document",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(store).selectPanel('voice'))),
        "is-active": _unref(store).panels.voice
      }, null, 8, ["number", "is-active"]),
      _createVNode(CustomPanel, {
        number: info.value.messages.photo_video,
        label: "Photo & Video",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(store).selectPanel('photo'))),
        "is-active": _unref(store).panels.photo
      }, null, 8, ["number", "is-active"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(CustomPanel, {
        icon: _unref(PieChart02),
        number: info.value.errors.total,
        type: "error",
        size: "large",
        label: "All errors",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(store).selectPanel('allErrors'))),
        "is-active": _unref(store).panels.allErrors
      }, null, 8, ["icon", "number", "is-active"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(CustomPanel, {
        number: info.value.errors.reply_time,
        type: "error",
        label: "Reply time",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(store).selectPanel('replyTime'))),
        "is-active": _unref(store).panels.replyTime
      }, null, 8, ["number", "is-active"]),
      _createVNode(CustomPanel, {
        number: info.value.errors.unanswered,
        type: "error",
        label: "Unanswered",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(store).selectPanel('unanswered'))),
        "is-active": _unref(store).panels.unanswered
      }, null, 8, ["number", "is-active"]),
      _createVNode(CustomPanel, {
        number: info.value.errors.deleted,
        type: "error",
        label: "Deleted",
        onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(store).selectPanel('deleted'))),
        "is-active": _unref(store).panels.deleted
      }, null, 8, ["number", "is-active"]),
      _createVNode(CustomPanel, {
        number: info.value.errors.edited,
        type: "error",
        label: "Edited",
        onClick: _cache[9] || (_cache[9] = ($event: any) => (_unref(store).selectPanel('edited'))),
        "is-active": _unref(store).panels.edited
      }, null, 8, ["number", "is-active"])
    ])
  ], 2))
}
}

})